module.exports = __webpack_public_path__ + "static/media/feature2.553dd496.png";